export default __webpack_public_path__ + "img/1_13-25d6b627.png";